import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const searchPassportReports = async (params) => {
   try {
      const url = api.fullUrl(
        '/api/v1/reports/passportV2',
        params.filters,
        null,
        null,
        {field: params.sort_by, direction: params.sort_direction},
        { page: params.page, per_page: params.per_page }
      );
      const response = await api.query(url);
      return response;
    } catch (error) {
    }
}

export const exportPassportReports = ({filters, order, orderBy}) => {
  var sortingParams = {
    direction: order,
    field: orderBy
  };
  return api.fullUrl('/api/v1/reports/passportV2.csv', filters, null, null, sortingParams, null);
};
